<ng-container stagesSlot="main" />
